/*
  BMP variant image preload
  Downloads each color's main product photo in the background so a color tap
  doesn't have to wait on a photo download.

  - Starts only after the page has fully loaded, the browser is idle, and the
    shopper has stayed ~1.5s. Initial page load is untouched.
  - One photo at a time, low priority, in swatch order.
  - Skips Save-Data and slow-2g/2g/3g connections.
  - Touching (or hovering, on desktop) a swatch fetches that color immediately.
  - Reuses the gallery's own srcset/sizes so the browser picks the exact file
    the gallery will request after the swap (no duplicate downloads).
  - Read-only: does not touch price, availability, variant or cart logic.

  Data: snippets/bmp-variant-image-preload.liquid (rendered from bmp-body).
*/
(function () {
  'use strict';
  if (window.__bmpVariantPreload) return;
  window.__bmpVariantPreload = true;

  var DWELL_MS = 1500;

  var dataEl = document.querySelector('script[data-bmp-variant-preload]');
  if (!dataEl) return;
  var colors;
  try {
    colors = (JSON.parse(dataEl.textContent).colors || []).filter(function (c) {
      return c && c.src;
    });
  } catch (e) {
    return;
  }
  if (colors.length < 2) return;

  var conn = navigator.connection || {};
  var constrained = conn.saveData === true || /^(slow-2g|2g|3g)$/.test(conn.effectiveType || '');

  var requested = {};
  var queue = [];
  var running = false;

  function baseOf(url) {
    return String(url || '').split('?')[0].replace(/^https?:/, '');
  }

  function vOf(url) {
    var m = /[?&]v=([^&]+)/.exec(String(url || ''));
    return m ? m[1] : null;
  }

  function mainImage() {
    var galleries = document.querySelectorAll('media-gallery');
    for (var i = 0; i < galleries.length; i++) {
      var g = galleries[i];
      if (g.closest('dialog, product-card, quick-add-dialog')) continue;
      return (
        g.querySelector('img.product-media__image[fetchpriority="high"]') ||
        g.querySelector('img.product-media__image')
      );
    }
    return null;
  }

  // Same widths/params as the live gallery image, pointed at another color's file.
  function swapSrcset(srcset, target) {
    var tBase = baseOf(target);
    var tV = vOf(target);
    return srcset
      .split(',')
      .map(function (part) {
        var bits = part.trim().split(/\s+/);
        if (!bits[0]) return '';
        var url = bits[0];
        var q = url.indexOf('?');
        var query = q >= 0 ? url.slice(q) : '';
        if (tV) {
          if (/[?&]v=/.test(query)) query = query.replace(/([?&]v=)[^&]*/, '$1' + tV);
          else query = query ? query + '&v=' + tV : '?v=' + tV;
        }
        return tBase + query + (bits[1] ? ' ' + bits[1] : '');
      })
      .filter(Boolean)
      .join(', ');
  }

  function fetchColor(color, priority) {
    var key = baseOf(color.src);
    if (requested[key]) return Promise.resolve();
    var img = mainImage();
    if (!img) return Promise.resolve();
    requested[key] = true;
    if (baseOf(img.currentSrc || img.src) === key) return Promise.resolve();

    return new Promise(function (resolve) {
      var pre = new Image();
      var finish = function () {
        resolve();
      };
      pre.onload = finish;
      pre.onerror = finish;
      setTimeout(finish, 10000);
      try {
        pre.fetchPriority = priority;
      } catch (e) {}
      pre.decoding = 'async';
      var srcset = img.getAttribute('srcset');
      var sizes = img.getAttribute('sizes');
      if (srcset) {
        if (sizes) pre.sizes = sizes;
        pre.srcset = swapSrcset(srcset, color.src);
      } else {
        pre.src = color.src;
      }
    });
  }

  function selectedColor() {
    var inputs = document.querySelectorAll('variant-picker input[type="radio"]:checked');
    for (var i = 0; i < inputs.length; i++) {
      for (var j = 0; j < colors.length; j++) {
        if (colors[j].value === inputs[i].value) return colors[j].value;
      }
    }
    return null;
  }

  function pump() {
    if (running) return;
    var next = queue.shift();
    if (!next) return;
    if (document.hidden) {
      queue.unshift(next);
      document.addEventListener('visibilitychange', pump, { once: true });
      return;
    }
    running = true;
    fetchColor(next, 'low').then(function () {
      running = false;
      pump();
    });
  }

  function start() {
    if (constrained) return;
    var current = selectedColor();
    queue = colors.filter(function (c) {
      return c.value !== current;
    });
    pump();
  }

  function colorFromEvent(e) {
    var label = e.target && e.target.closest ? e.target.closest('variant-picker label') : null;
    if (!label) return null;
    var input =
      label.querySelector('input[type="radio"]') ||
      (label.htmlFor ? document.getElementById(label.htmlFor) : null);
    if (!input) return null;
    for (var i = 0; i < colors.length; i++) {
      if (colors[i].value === input.value) return colors[i];
    }
    return null;
  }

  function boost(e) {
    if (e.type === 'pointerover' && e.pointerType !== 'mouse') return;
    var c = colorFromEvent(e);
    if (!c) return;
    queue = queue.filter(function (q) {
      return q !== c;
    });
    fetchColor(c, 'high');
  }

  document.addEventListener('pointerdown', boost, { capture: true, passive: true });
  document.addEventListener('pointerover', boost, { capture: true, passive: true });

  function schedule() {
    var idle =
      window.requestIdleCallback ||
      function (cb) {
        return setTimeout(cb, 200);
      };
    idle(
      function () {
        setTimeout(start, DWELL_MS);
      },
      { timeout: 3000 }
    );
  }

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
